<script setup>
import Step from "@Components/Stepper/Step.vue";
import Congratulations from "@Components/Congratulations.vue";
import { FormInput, FormCard } from "@Components/Form";
import { useI18n } from "vue-i18n";
import { PrimaryButton } from "@Components/Button";
import { useForm } from "@/form";
import ActionMessage from "@Components/ActionMessage.vue";
import { useStore as useTemplatesStore } from "@/Stores/templates";

const props = defineProps(["modelValue", "step", "project"]);
defineEmits(["update:modelValue", "next", "back", "skip"]);

const { t: __ } = useI18n();
const templatesStore = useTemplatesStore();

const storeTemplateForm = useForm({
    name: "",
    project: props.project.id,
});

const storeTemplate = async () => {
    if (storeTemplateForm.processing) return;

    await storeTemplateForm.post("templates_store");

    templatesStore.fetch();
};
</script>

<template>
    <Step :step="step" :processing="modelValue.processing" @next="$emit('next')" @back="$emit('back')" @skip="$emit('skip')" class="relative lg:px-8 sm:px-6">
        <template #header>
            <div class="mx-auto max-w-3xl px-4 sm:px-0">
                <h3 class="text-4xl font-semibold leading-tight text-center text-gray-900 dark:text-white">
                    {{ __("Votre projet a bien été créé.") }}
                </h3>
            </div>
        </template>

        <div class="mx-auto max-w-4xl flex flex-col space-y-6">
            <FormCard :title="__('Enregistrer un template')">
                <FormInput :label="__('Nom du template')" v-model="storeTemplateForm.name" :errors="storeTemplateForm.getErrors('name')" />
                <div class="flex justify-end items-center">
                    <ActionMessage :on="storeTemplateForm.recentlySuccessful" class="mr-3"> {{ __("Sauvegardé.") }} </ActionMessage>
                    <PrimaryButton :processing="storeTemplateForm.processing" @click="storeTemplate"> {{ __("Sauvegarder le template") }} </PrimaryButton>
                </div>
            </FormCard>
        </div>

        <Congratulations />
    </Step>
</template>
